var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("csp-table", {
    ref: "table",
    attrs: {
      icon: _vm.icon,
      "items-ajax-url": _vm.itemsAjaxUrl,
      "row-class": _vm.rowClass,
      scrollable: true,
      "table-headline": _vm.tableHeadline,
    },
    on: {
      "row-clicked": _vm.onRowClicked,
      "row-contextmenu": _vm.onRowContextmenu,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "above-body",
          fn: function () {
            return [_vm._t("above-body")]
          },
          proxy: true,
        },
        {
          key: "cell(actions)",
          fn: function ({ data }) {
            return [_vm._t("cell(actions)", null, { data: data })]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }